import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import Container from '../../components/LandingPage/Container';
import {
  AttachMoneyOutlined,
  CurrencyExchangeOutlined,
  LocalShippingOutlined,
  VerifiedUserOutlined,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const BrainOutlineIcon: React.FC = () => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_665_156"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="33"
        height="33"
      >
        <rect width="33" height="33" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_665_156)">
        <path
          d="M11.1029 27.5C10.8508 27.5 10.616 27.437 10.3982 27.3109C10.1805 27.1849 10.0144 27.0073 9.89981 26.7781L7.21855 22H9.2123L10.5873 24.75H13.7498V23.375H11.4123L10.0373 20.625H6.4623L4.50293 17.1875C4.4571 17.0729 4.41699 16.9583 4.38262 16.8438C4.34824 16.7292 4.33105 16.6146 4.33105 16.5C4.33105 16.4083 4.38835 16.1792 4.50293 15.8125L6.4623 12.375H10.0373L11.4123 9.625H13.7498V8.25H10.5873L9.2123 11H7.21855L9.89981 6.22188C10.0144 5.99271 10.1805 5.8151 10.3982 5.68906C10.616 5.56302 10.8508 5.5 11.1029 5.5H14.4373C14.8269 5.5 15.1535 5.63177 15.417 5.89531C15.6805 6.15885 15.8123 6.48542 15.8123 6.875V12.375H13.7498L12.3748 13.75H15.8123V17.875H12.7873L11.4123 15.125H8.2498L6.8748 16.5H10.5873L11.9623 19.25H15.8123V26.125C15.8123 26.5146 15.6805 26.8411 15.417 27.1047C15.1535 27.3682 14.8269 27.5 14.4373 27.5H11.1029ZM18.5623 27.5C18.1727 27.5 17.8462 27.3682 17.5826 27.1047C17.3191 26.8411 17.1873 26.5146 17.1873 26.125V19.25H21.0373L22.4123 16.5H26.1248L24.7498 15.125H21.5873L20.2123 17.875H17.1873V13.75H20.6248L19.2498 12.375H17.1873V6.875C17.1873 6.48542 17.3191 6.15885 17.5826 5.89531C17.8462 5.63177 18.1727 5.5 18.5623 5.5H21.8967C22.1488 5.5 22.3837 5.56302 22.6014 5.68906C22.8191 5.8151 22.9852 5.99271 23.0998 6.22188L25.7811 11H23.7873L22.4123 8.25H19.2498V9.625H21.5873L22.9623 12.375H26.5373L28.4967 15.8125C28.5425 15.9271 28.5826 16.0417 28.617 16.1562C28.6514 16.2708 28.6686 16.3854 28.6686 16.5C28.6686 16.5917 28.6113 16.8208 28.4967 17.1875L26.5373 20.625H22.9623L21.5873 23.375H19.2498V24.75H22.4123L23.7873 22H25.7811L23.0998 26.7781C22.9852 27.0073 22.8191 27.1849 22.6014 27.3109C22.3837 27.437 22.1488 27.5 21.8967 27.5H18.5623Z"
          fill="#80C343"
        />
      </g>
    </svg>
  );
};

const LaptopWindowsOutlinedIcon: React.FC = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_665_171"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_665_171)">
        <path
          d="M1.25 26.25V23.75H28.75V26.25H1.25ZM5 22.5C4.3125 22.5 3.72396 22.2552 3.23438 21.7656C2.74479 21.276 2.5 20.6875 2.5 20V6.25C2.5 5.5625 2.74479 4.97396 3.23438 4.48438C3.72396 3.99479 4.3125 3.75 5 3.75H25C25.6875 3.75 26.276 3.99479 26.7656 4.48438C27.2552 4.97396 27.5 5.5625 27.5 6.25V20C27.5 20.6875 27.2552 21.276 26.7656 21.7656C26.276 22.2552 25.6875 22.5 25 22.5H5ZM5 20H25V6.25H5V20ZM13.75 18.125H16.25V12.9062L18.25 14.875L20 13.125L15 8.125L10 13.125L11.75 14.9062L13.75 12.9062V18.125Z"
          fill="#F4F4F4"
        />
      </g>
    </svg>
  );
};

/* eslint-disable react/prop-types */

const HowItWorksCard: React.FC<{ icon: React.ReactNode; title: string; description: string }> = ({
  icon,
  title,
  description,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="13px"
      padding="20px 17px"
      bgcolor="var(--acer-dark)"
      width="100%"
    >
      <Typography color="var(--acer-green)">{icon}</Typography>
      <Typography
        color="white"
        fontSize="16px"
        fontWeight="500"
        lineHeight="24px"
        letterSpacing="0.15px"
      >
        {title}
      </Typography>
      <Typography
        color="white"
        fontSize="14px"
        fontWeight="400"
        lineHeight="20px"
        letterSpacing="0.25px"
      >
        {description}
      </Typography>
    </Box>
  );
};

const CustomerCard: React.FC<{ icon: React.ReactNode; title: string }> = ({ icon, title }) => {
  return (
    <Box
      width="100%"
      height="108px"
      padding="20px 9px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="11px"
      bgcolor="var(--acer-green)"
    >
      <Typography color="white">{icon}</Typography>
      <Typography
        color="white"
        fontSize="16px"
        fontWeight="500"
        lineHeight="24px"
        letterSpacing="0.15px"
      >
        {title}
      </Typography>
    </Box>
  );
};

const HowItWorks: React.FC = () => {
  const navigate = useNavigate();
  const howItWorksCards = [
    {
      icon: <LocalShippingOutlined />,
      title: 'Logística da Fábrica para o Cliente',
      description:
        'Você indica. A Acer entrega. Faturamento direto, sem custos extras ou burocracia.',
    },
    {
      icon: <BrainOutlineIcon />,
      title: 'Plataforma Digital CISP1',
      description:
        'Ferramentas completas para você cadastrar oportunidades, fazer cotações e acompanhar pedidos.',
    },
    {
      icon: <CurrencyExchangeOutlined />,
      title: 'Venda Consultiva com Receita Recorrente',
      description:
        'Atue como especialista. Ganhe comissões agressivas e fortaleça o relacionamento com seus clientes.',
    },
  ];

  const customerCards = [
    {
      icon: <LocalShippingOutlined />,
      title: 'Frete grátis para todo o Brasil',
    },
    {
      icon: <LaptopWindowsOutlinedIcon />,
      title: 'Windows Pro pré-instalado',
    },
    {
      icon: <VerifiedUserOutlined />,
      title: 'Garantia on-site (assistência no local)',
    },
    {
      icon: <AttachMoneyOutlined />,
      title: 'Compra faturada direto da Acer',
    },
  ];

  return (
    <Box bgcolor="var(--acer-lightgray)" padding="28px 0 28px">
      <Container>
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="column" gap="19px" width="100%">
            <Typography fontSize="28px" fontWeight="400" lineHeight="36px" letterSpacing="0">
              Como funciona o modelo Acer para Revendas?
            </Typography>
            <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
              <Box
                display={{ xs: 'none', lg: 'flex' }}
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                width="362px"
              >
                <img
                  width="100%"
                  height="auto"
                  src="/images/how-it-works.png"
                  alt="Como funciona o modelo Acer para Revendas?"
                />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap="19px"
                width={{ xs: '100%', lg: '702px' }}
              >
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap="10px">
                  {howItWorksCards.map(howItWorksCard => (
                    <HowItWorksCard
                      key={howItWorksCard.title}
                      icon={howItWorksCard.icon}
                      title={howItWorksCard.title}
                      description={howItWorksCard.description}
                    />
                  ))}
                </Box>
                <Typography fontSize="24px" fontWeight="400" lineHeight="32px" letterSpacing="0">
                  Seu cliente também sai ganhando
                </Typography>
                <Grid container spacing={1}>
                  {customerCards.map(customerCard => (
                    <Grid item xs={12} md={6} width="100%" key={customerCard.title}>
                      <CustomerCard icon={customerCard.icon} title={customerCard.title} />
                    </Grid>
                  ))}
                </Grid>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--acer-dark)',
                    fontWeight: '500',
                    color: 'white',
                    '&:hover': { backgroundColor: 'var(--acer-mediumgray)', color: 'white' },
                  }}
                  onClick={() => navigate('/register')}
                >
                  <Typography
                    display={{ xs: 'none', md: 'block' }}
                    color="white"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="24px"
                    letterSpacing="0.46px"
                  >
                    Cadastre-se agora e tenha acesso a todas as vantagens!
                  </Typography>
                  <Typography
                    display={{ xs: 'block', md: 'none' }}
                    color="white"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="24px"
                    letterSpacing="0.46px"
                  >
                    Cadastre-se agora
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorks;
